<template>
  <div class="echart-box-cla">
    <div class="chart_title_cla">
      <div class="title-bg-cla"></div>
      <div class="title-Text-cla">{{ $t('dashboard.deviceTypetop10') }}</div>
    </div>
    <div id="device_bar_chart" class="echart-cla"></div>
  </div>
</template>

<script>
import { getOptionConfig } from './barChar.js'
import { devTypeTotal } from '@/services/dashboardApi.js'
var echarts = require('echarts')
export default {
  data() {
    return {
      barChart: null,
      category: [],
      barData: [],
      dataList: [],
      timeout: null,
      intervaldevTypeBar: null
    }
  },
  mounted() {
    let _this = this
    this.getData()
    window.addEventListener('resize', this.resizeChart, true)
    this.intervaldevTypeBar = setInterval(() => {
      _this.getData()
    }, 10000)
  },
  beforeDestroy() {
    this.barChart.clear()
    this.barChart.dispose()
    window.removeEventListener('resize', this.resizeChart, true)
    if (this.intervaldevTypeBar) {
      clearInterval(this.intervaldevTypeBar)
    }
  },
  methods: {
    resizeChart() {
      if (this.barChart) {
        this.debounce(this.barChart.resize, 200)
      }
    },
    debounce(func, wait) {
      let context = this
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
      this.timeout = setTimeout(() => {
        func.apply(context, arguments)
      }, wait)
    },
    getOption() {
      let lang = {
        title: this.$t('dashboard.deviceTypetop10')
      }
      let option = getOptionConfig(this.category, this.barData, lang)
      this.renderChart(option)
    },
    renderChart(option) {
      if (!this.barChart) {
        this.barChart = echarts.init(
          document.getElementById('device_bar_chart')
        )
      }
      this.barChart.setOption(option, true)
    },

    getData() {
      devTypeTotal().then((data) => {
        if (data.code === '00000000') {
          let result = data.payload.data
          this.category = result.key.reverse()
          this.barData = result.value.reverse()
          this.getOption()
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
// .deviceTypeChart-box-cla {
//   position: relative;
//   height: 100%;
//   width: 100%;
//   box-sizing: border-box;
//   padding: 14px;
//   background: rgba(79, 234, 237, 0.1);
//   border: 1px solid rgba(79, 234, 237, 0.6);
//   box-shadow: inset 0 1px 18px 0 rgba(0, 246, 201, 0.6);
// }
// .deviceTypeChart-cla {
//   height: 100%;
//   width: 100%;
// }
</style>



// WEBPACK FOOTER //
// src/modules/tenantManager/dashboard/deviceTypeChart/deviceTypeChart.vue